const SET_BUTTONS_EXPANDED = (state, bool) => {
  state.buttonsExpanded = bool;
};
const SET_CONTENT_WIDTH_TO_DEFAULT = (state) => {
  state.contentWidth = state.defaultContentWidth;
};
const SET_CONTENT_WIDTH = (state, width) => {
  state.contentWidth = width;
};
export default {
  SET_CONTENT_WIDTH_TO_DEFAULT,
  SET_BUTTONS_EXPANDED,
  SET_CONTENT_WIDTH,
};
